import { Type } from 'typebox';
import { ReadyRosieVideo } from '@tadpoles/common';
export const VideosPayload = Type.Object({
    timestamp: Type.Integer(),
    readyRosieVideos: Type.Array(ReadyRosieVideo),
    cursor: Type.Optional(Type.String())
});
export class HttpVideosResource {
    #httpClient;
    constructor(httpClient) {
        this.#httpClient = httpClient;
    }
    async list(request = {}, options) {
        const queryParams = {
            paging: 'true'
        };
        if (Number.isSafeInteger(request.timestamp)) {
            queryParams['timestamp'] = String(request.timestamp);
        }
        if (typeof request.cursor !== 'undefined') {
            queryParams['cursor'] = request.cursor;
        }
        return this.#httpClient.get({
            path: '/library/ready_rosie_videos',
            queryParams,
            payloadSchema: VideosPayload,
            signal: options?.signal
        });
    }
}
